import { exportsModule } from '@cian/mf-registry/browser';

import { createFeedbackFormConstructor } from '../services/WebComponent/createFeedbackFormConstructor';
import { createApplicationContext } from '../services/applicationContext';
import { createApplicationState } from '../services/applicationState';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/v1/get-feedback-form-microfrontend/': () => ({
        customElementConstructor: createFeedbackFormConstructor(context, store),
      }),
    },
  });
}
